import React, { Component, Fragment } from 'react'
import './PerformanceRow.css'

class GreeksRow extends Component {
  formatPercent(number) {
    const { type } = this.props

    if (type === 'beta' || type === 'sharpeRatio') {
      return number !== null ? parseFloat(number).toFixed(2) : '-'
    }
    return number !== null ? `${parseFloat(number * 100).toFixed(2)}%` : '-'
  }
  formatDate(string) {
    return new Date(string).toLocaleDateString([], { timeZone: 'UTC' })
  }

  render() {
    const { fund, type } = this.props

    if (fund[type] === null) {
      return null
    }

    // const inceptionDate = new Date(fund.inceptionDate).toLocaleDateString()
    return (
      <Fragment>
        <tr className='greyline'>
          <td width='70' className='textLeft'>
            {(() => {
              switch (fund.type) {
                case 'BMK':
                  return fund.ticker.toUpperCase();
                case 'BLEND':
                case 'COD':
                  return "-";
                default:
                  return fund.fundPageURL ? (
                    <a className='tickerLink' href={fund.fundPageURL} target='_new'>
                      {fund.ticker}
                    </a>
                  ) : (
                    <a className='tickerLink' href={fund.msUrl} target='_new'>
                      {fund.ticker}
                    </a>
                  );
              }
            })()}
          </td>
          {['WTIDX'].includes(fund.type) ? (
            <td width='300' className='textLeft'>
              {fund.name.replace(/&amp;/g, '&')}
            </td>
          ) : (
            <td width='300' className='textLeft'>
              {`${fund.name.replace(/&amp;/g, '&')} (NAV)`}
            </td>
          )}
          <td className='textCenter'>{this.formatDate(fund.inceptionDate)}</td>
          <td className='textCenter'>
            {this.formatPercent(fund[type].commonPeriodNAV)}
            <br />
          </td>
          <td className='textCenter'>
            {this.formatPercent(fund[type].yrs1NAV)}
            <br />
          </td>
          <td className='textCenter'>
            {this.formatPercent(fund[type].yrs3NAV)}
            <br />
          </td>
          <td className='textCenter'>
            {this.formatPercent(fund[type].yrs5NAV)}
            <br />
          </td>
          <td className='textCenter'>
            {this.formatPercent(fund[type].yrs10NAV)}
            <br />
          </td>
          {fund[type].type === 'BMK' ? (
            <td className='textCenter'>
              -<br />
            </td>
          ) : (
            <td className='textCenter'>
              {this.formatPercent(fund[type].inceptionNAV)}
              <br />
            </td>
          )}

        </tr>
      </Fragment>
    )
  }
}

export default GreeksRow
